import type { ImportHeaderField } from './matchHeaders';

const NAME = {
  field: 'name',
  aliases: ['bezeichnung', 'standort', 'standortname', 'baustelle'],
} as const satisfies ImportHeaderField;
const LATITUDE = {
  field: 'latitude',
  aliases: ['lat', 'breitengrad'],
} as const satisfies ImportHeaderField;
const LONGITUDE = {
  field: 'longitude',
  aliases: ['lng', 'lon', 'laengengrad'],
} as const satisfies ImportHeaderField;
const CITY = {
  field: 'city',
  aliases: ['ort', 'stadt'],
} as const satisfies ImportHeaderField;
const COUNTRY = {
  field: 'country',
  aliases: ['land'],
} as const satisfies ImportHeaderField;
const POST_CODE = {
  field: 'post_code',
  aliases: ['postalcode', 'plz', 'zip'],
} as const satisfies ImportHeaderField;
const STREET_NAME = {
  field: 'street_name',
  aliases: ['street', 'strasse'],
} as const satisfies ImportHeaderField;
const BUILDING_NUMBER = {
  field: 'building_number',
  aliases: ['hausnummer', 'housenumber'],
} as const satisfies ImportHeaderField;
const COMPANY_ID = {
  field: 'company_id',
  aliases: ['firmenid'],
} as const satisfies ImportHeaderField;
const ORG_UNITS = {
  field: 'org_units',
  aliases: ['organisationseinheit'],
} as const satisfies ImportHeaderField;
const SYNC_KEY = {
  field: 'sync_key',
  aliases: ['externeid', 'externalid', 'syncid'],
} as const satisfies ImportHeaderField;

const SITE_LOCATION_FIELDS = [
  LATITUDE,
  LONGITUDE,
  CITY,
  COUNTRY,
  POST_CODE,
  STREET_NAME,
  BUILDING_NUMBER,
  COMPANY_ID,
  ORG_UNITS,
  SYNC_KEY,
] as const;

export const SITE_IMPORT_HEADER_FIELDS = [
  NAME,
  { field: 'type', aliases: ['typ'] },
  ...SITE_LOCATION_FIELDS,
] as const satisfies readonly ImportHeaderField[];

export const SITE_WITH_COST_CENTER_IMPORT_HEADER_FIELDS = [
  NAME,
  { field: 'cost_centers', aliases: ['kostenstelle', 'kostenstellen', 'kst'] },
  ...SITE_LOCATION_FIELDS,
] as const satisfies readonly ImportHeaderField[];

export const USER_IMPORT_HEADER_FIELDS = [
  { field: 'email', aliases: ['mail'] },
  { field: 'first_name', aliases: ['vorname'] },
  { field: 'last_name', aliases: ['nachname', 'surname'] },
  { field: 'password', aliases: ['passwort', 'kennwort'] },
  { field: 'position', aliases: ['funktion', 'rolle'] },
  { field: 'is_active', aliases: ['aktiv', 'active'] },
  { field: 'permitted_signature_types', aliases: ['signaturtypen'] },
  { field: 'user_type', aliases: ['benutzertyp'] },
  COMPANY_ID,
  ORG_UNITS,
] as const satisfies readonly ImportHeaderField[];
